<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

const DEFAULT_PIPELINES = [
    "Calificación Leads",
    "Admisiones Advance"
];
const SEARCH_DATE_RANGE = {
    desde: "2026-07-01",
    hasta: "2026-07-31"
};

export default {
    components: { Layout, PageHeader },
    props: {
        embedded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: "Métricas HubSpot",
            cargando: false,
            exportando: false,
            sincronizando: false,
            actualizandoMovimientosDia: false,
            guardandoMetas: false,
            cargandoReportePeriodo: false,
            cargandoCalificacionLeads: false,
            cargandoDesgloseCalificacionLeads: false,
            cargandoArancelMatriculados: false,
            showMissingTuitionDealsModal: false,
            syncPolling: false,
            syncPollTimer: null,
            error: "",
            metasMensaje: "",
            resultados: [],
            cache: null,
            sync: null,
            advanceReport: {
                available: false,
                report_pipeline: "advance",
                report_pipeline_label: "Pipeline Advance",
                report_pipeline_options: [],
                report_period_options: [],
                periodo: "",
                pipeline_id: "",
                source: "Consulta HubSpot por período",
                status: "legacy",
                last_sync_status: "",
                error: null,
                as_of: null,
                synced_at: null,
                total_deals_con_carrera: 0,
                matriculados_total: 0,
                matriculados_contactos_total: 0,
                metas_comerciales: {
                    meta_total: 0,
                    matriculados_total: 0,
                    avance_porcentaje: 0
                },
                stages: [],
                matriculados_por_carrera: []
            },
            leadQualificationReport: {
                available: false,
                report_period_options: [],
                lead_qualification_program: "advance",
                lead_qualification_program_label: "Advance",
                lead_qualification_program_options: [],
                tipo_programa: "Advance",
                periodo: "",
                pipeline_id: "",
                pipeline_label: "Calificación Leads",
                source: "Consulta HubSpot por período",
                as_of: null,
                synced_at: null,
                total_deals: 0,
                stages: []
            },
            expandedBreakdowns: {},
            fuenteSeleccionada: null,
            resumenLeads: {
                total: 0,
                periodos: []
            },
            conversion: {
                matriculatedStage: "Matriculado",
                overall: {
                    total: 0,
                    matriculados: 0,
                    conversionRate: 0
                },
                paidSearch: {
                    source: "Búsqueda de pago",
                    total: 0,
                    matriculados: 0,
                    conversionRate: 0
                },
                sources: []
            },
            meta: {
                current_page: 1,
                last_page: 1,
                per_page: 50,
                from: 0,
                to: 0,
                total: 0
            },
            filtros: {
                desde: SEARCH_DATE_RANGE.desde,
                hasta: SEARCH_DATE_RANGE.hasta,
                tipoPrograma: "Advance",
                busqueda: "",
                pipelines: [...DEFAULT_PIPELINES],
                sinFiltroPipeline: false,
                perPage: 50
            },
            pipelineOptions: DEFAULT_PIPELINES,
            reportPipeline: "advance",
            reportPeriod: "",
            leadQualificationPeriod: "",
            leadQualificationProgram: "advance",
            leadQualificationSelectedStage: "Asignación Coordinación",
            leadQualificationBreakdown: {
                stage_label: "Asignación Coordinación",
                total: 0,
                teams: [],
                owners: []
            },
            matriculatedTuitionReport: {
                available: false,
                periodo: "",
                grupo: "all",
                visibilidad: "visible",
                matriculados: 0,
                arancel_total: 0,
                monto_real_total: 0,
                diferencia_total: 0,
                arancel_sin_monto_total: 0,
                negocios_con_monto: 0,
                negocios_sin_monto: 0,
                sin_arancel: 0,
                groups: [],
                careers: []
            },
            tuitionGroupFilter: "all",
            tuitionVisibilityFilter: "visible",
            careerVisibilityFilter: "visible",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Métricas HubSpot",
                    active: true
                }
            ]
        };
    },
    computed: {
        layoutComponent() {
            return this.embedded ? "div" : "Layout";
        },
        isDirector() {
            return this.user && this.user.rol === "Director";
        },
        missingTuitionDeals() {
            return this.matriculatedTuitionReport.careers.flatMap(career => {
                return career.negocios_sin_monto_detalle.map(deal => ({
                    ...deal,
                    carrera: career.carrera,
                    grupo_label: career.grupo_label,
                    arancel: career.arancel_unitario
                }));
            });
        },
        leadQualificationStageCards() {
            return [
                {
                    label: "Total",
                    total: Number(this.leadQualificationReport.total_deals || 0)
                },
                ...this.leadQualificationReport.stages
            ];
        },
        leadQualificationBreakdownOwnersTotal() {
            return this.leadQualificationBreakdown.owners.reduce((total, owner) => {
                return total + Number(owner.total || 0);
            }, 0);
        },
        fuenteSeleccionadaMetric() {
            return this.conversion.sources.find(source => source.source_value === this.fuenteSeleccionada) || null;
        },
        syncRun() {
            return this.sync && this.sync.current_run ? this.sync.current_run : null;
        },
        syncProgressPercent() {
            const run = this.syncRun;
            if (!run) {
                return 0;
            }

            return Math.max(0, Math.min(100, Number(run.progress_percent || 0)));
        },
        syncProgressStage() {
            const labels = {
                queued: "En cola",
                starting: "Iniciando",
                cache: "Sincronizando caché general",
                panel: "Consultando panel de HubSpot",
                report: "Generando reporte agregado",
                completed: "Completado",
                failed: "Actualización fallida"
            };

            return labels[this.syncRun && this.syncRun.progress_stage] || "Sincronización";
        },
        syncProgressVisible() {
            return Boolean(this.syncRun && ["queued", "running", "failed"].includes(this.syncRun.status));
        },
        syncProgressCounter() {
            const run = this.syncRun;
            if (!run || run.progress_current === null || run.progress_current === undefined || !run.progress_total) {
                return "";
            }

            return `${Number(run.progress_current)} de ${Number(run.progress_total)}`;
        },
        visibleCommercialCareers() {
            const careers = this.advanceReport.matriculados_por_carrera;
            let filteredCareers = careers.filter(career => !career.hidden);

            if (this.isDirector) {
                return this.sortByRateDesc(filteredCareers, "avance_porcentaje", "total", "carrera");
            }

            if (this.careerVisibilityFilter === "hidden") {
                filteredCareers = careers.filter(career => career.hidden);
            }

            if (this.careerVisibilityFilter === "all") {
                filteredCareers = careers;
            }

            return this.sortByRateDesc(filteredCareers, "avance_porcentaje", "total", "carrera");
        },
        hiddenCommercialCareersCount() {
            return this.advanceReport.matriculados_por_carrera.filter(career => career.hidden).length;
        },
        commercialGoalTotal() {
            return this.visibleCommercialCareers.reduce((total, career) => total + Number(career.meta || 0), 0);
        },
        commercialGoalMatriculadosTotal() {
            return this.visibleCommercialCareers.reduce((total, career) => total + Number(career.total || 0), 0);
        },
        previousPeriodMatriculadosTotal() {
            return this.visibleCommercialCareers.reduce((total, career) => total + Number(career.matriculados_periodo_anterior || 0), 0);
        },
        commercialGoalProgressTotal() {
            return this.calculateGoalProgress(this.commercialGoalMatriculadosTotal, this.commercialGoalTotal);
        },
        commercialGoalGrowthTotal() {
            return this.calculateGrowthPercentage(this.commercialGoalTotal, this.previousPeriodMatriculadosTotal);
        }
    },
    mounted() {
        this.cargarResultados();
    },
    methods: {
        parametrosConsulta(page = null) {
            const params = {
                desde: this.filtros.desde,
                hasta: this.filtros.hasta,
                tipo_programa: this.filtros.tipoPrograma,
                busqueda: this.filtros.busqueda,
                pipeline_historico: this.filtros.sinFiltroPipeline ? [] : this.filtros.pipelines,
                sin_filtro_pipeline: this.filtros.sinFiltroPipeline ? 1 : 0,
                per_page: this.filtros.perPage,
                lead_qualification_program: this.leadQualificationProgram
            };

            if (page !== null) {
                params.page = page;
            }

            return params;
        },
        validarRangoFechas() {
            if (!this.filtros.desde || !this.filtros.hasta) {
                this.error = "Selecciona las dos fechas del período.";
                return false;
            }

            if (this.filtros.desde > this.filtros.hasta) {
                this.error = "La fecha inicial no puede ser posterior a la fecha final.";
                return false;
            }

            return true;
        },
        async cargarResultados(page = 1) {
            if (!this.validarRangoFechas()) {
                return;
            }

            this.cargando = true;
            this.error = "";

            try {
                const { data } = await axios.get("/api/dashboard/advance", {
                    params: this.parametrosConsulta(page)
                });

                this.resultados = Array.isArray(data.data) ? data.data : [];
                this.meta = data.meta || this.meta;
                this.resumenLeads = this.normalizeSummary(data.summary, this.meta);
                this.cache = data.cache || null;
                this.sync = this.normalizeSyncStatus(data.sync);
                this.conversion = this.normalizeConversion(data.conversion);
                this.advanceReport = this.normalizeAdvanceReport(data.advance_report);
                this.leadQualificationReport = this.normalizeLeadQualificationReport(data.lead_qualification_report);
                this.reportPipeline = this.advanceReport.report_pipeline || this.reportPipeline;
                this.reportPeriod = this.advanceReport.periodo || this.reportPeriod;
                this.leadQualificationPeriod = this.leadQualificationReport.periodo || this.leadQualificationPeriod;
                this.leadQualificationProgram = this.leadQualificationReport.lead_qualification_program || this.leadQualificationProgram;
                this.usarDesgloseInicialCalificacionLeads();
                await this.cargarArancelMatriculados();
                this.metasMensaje = "";
            } catch (error) {
                this.resultados = [];
                this.resumenLeads = {
                    total: 0,
                    periodos: []
                };
                this.fuenteSeleccionada = null;
                this.sync = this.normalizeSyncStatus(null);
                this.conversion = this.normalizeConversion(null);
                this.advanceReport = this.normalizeAdvanceReport(null);
                this.leadQualificationReport = this.normalizeLeadQualificationReport(null);
                this.meta = {
                    current_page: 1,
                    last_page: 1,
                    per_page: this.filtros.perPage,
                    from: 0,
                    to: 0,
                    total: 0
                };
                this.error = error?.response?.data?.message || "No se pudieron cargar los datos locales.";
            } finally {
                this.cargando = false;
            }
        },
        async guardarMetasComerciales() {
            if (this.isDirector) {
                return;
            }

            if (!(this.reportPeriod || this.advanceReport.periodo) || !Array.isArray(this.advanceReport.matriculados_por_carrera)) {
                return;
            }

            this.guardandoMetas = true;
            this.error = "";
            this.metasMensaje = "";

            try {
                const { data } = await axios.post("/api/dashboard/advance/metas", {
                    periodo: this.reportPeriod || this.advanceReport.periodo,
                    report_pipeline: this.reportPipeline,
                    metas: this.advanceReport.matriculados_por_carrera.map(career => ({
                        carrera: career.carrera,
                        facultad: career.facultad,
                        hidden: Boolean(career.hidden),
                        meta: Number(career.meta || 0)
                    }))
                });

                this.advanceReport = this.normalizeAdvanceReport(data.advance_report);
                this.reportPipeline = this.advanceReport.report_pipeline || this.reportPipeline;
                this.reportPeriod = this.advanceReport.periodo || this.reportPeriod;
                this.metasMensaje = "Datos guardados: metas y visibilidad del período seleccionado; facultades compartidas entre períodos.";
                return true;
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudieron guardar las metas y la visibilidad del período seleccionado.";
                return false;
            } finally {
                this.guardandoMetas = false;
            }
        },
        async cambiarPipelineReporte() {
            if (!this.reportPipeline || !this.reportPeriod) {
                return;
            }

            this.cargandoReportePeriodo = true;
            this.error = "";
            this.metasMensaje = "";

            try {
                const { data } = await axios.get("/api/dashboard/advance/report", {
                    params: {
                        periodo: this.reportPeriod,
                        report_pipeline: this.reportPipeline
                    }
                });

                this.advanceReport = this.normalizeAdvanceReport(data.advance_report);
                this.reportPipeline = this.advanceReport.report_pipeline || this.reportPipeline;
                this.reportPeriod = this.advanceReport.periodo || this.reportPeriod;
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudo cargar el reporte por período.";
            } finally {
                this.cargandoReportePeriodo = false;
            }
        },
        cambiarPeriodoReporte() {
            this.cambiarPipelineReporte();
        },
        async cambiarPeriodoCalificacionLeads() {
            if (!this.leadQualificationPeriod || !this.leadQualificationProgram) {
                return;
            }

            this.cargandoCalificacionLeads = true;
            this.error = "";

            try {
                const { data } = await axios.get("/api/dashboard/advance/lead-qualification-report", {
                    params: {
                        periodo: this.leadQualificationPeriod,
                        report_pipeline: this.leadQualificationProgram
                    }
                });

                this.leadQualificationReport = this.normalizeLeadQualificationReport(data.lead_qualification_report);
                this.leadQualificationPeriod = this.leadQualificationReport.periodo || this.leadQualificationPeriod;
                this.leadQualificationProgram = this.leadQualificationReport.lead_qualification_program || this.leadQualificationProgram;
                this.usarDesgloseInicialCalificacionLeads();
                await this.cargarArancelMatriculados();
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudo cargar el reporte de Calificación Leads.";
            } finally {
                this.cargandoCalificacionLeads = false;
            }
        },
        cambiarProgramaCalificacionLeads() {
            this.cambiarPeriodoCalificacionLeads();
        },
        async cargarArancelMatriculados() {
            if (!this.hasRestrictedAccess || !this.leadQualificationPeriod) {
                return;
            }

            this.cargandoArancelMatriculados = true;
            try {
                const { data } = await axios.get("/api/dashboard/advance/matriculated-tuition-report", {
                    params: {
                        periodo: this.leadQualificationPeriod,
                        grupo: this.tuitionGroupFilter,
                        visibilidad: this.tuitionVisibilityFilter
                    }
                });
                this.matriculatedTuitionReport = this.normalizeMatriculatedTuitionReport(data.matriculated_tuition_report);
            } catch (error) {
                this.matriculatedTuitionReport = this.normalizeMatriculatedTuitionReport(null);
                this.error = error?.response?.data?.message || "No se pudo cargar el arancel de matriculados.";
            } finally {
                this.cargandoArancelMatriculados = false;
            }
        },
        normalizeMatriculatedTuitionReport(value) {
            const report = value || {};

            return {
                available: Boolean(report.available),
                periodo: report.periodo || this.leadQualificationPeriod,
                grupo: report.grupo || this.tuitionGroupFilter,
                visibilidad: report.visibilidad || this.tuitionVisibilityFilter,
                matriculados: Number(report.matriculados || 0),
                arancel_total: Number(report.arancel_total || 0),
                monto_real_total: Number(report.monto_real_total || 0),
                diferencia_total: Number(report.diferencia_total || 0),
                arancel_sin_monto_total: Number(report.arancel_sin_monto_total || 0),
                negocios_con_monto: Number(report.negocios_con_monto || 0),
                negocios_sin_monto: Number(report.negocios_sin_monto || 0),
                sin_arancel: Number(report.sin_arancel || 0),
                groups: Array.isArray(report.groups) ? report.groups.map(group => ({
                    grupo: group.grupo || "",
                    label: group.label || group.grupo || "Sin grupo",
                    matriculados: Number(group.matriculados || 0),
                    arancel_total: Number(group.arancel_total || 0),
                    monto_real_total: Number(group.monto_real_total || 0),
                    diferencia_total: Number(group.diferencia_total || 0),
                    arancel_sin_monto_total: Number(group.arancel_sin_monto_total || 0),
                    negocios_con_monto: Number(group.negocios_con_monto || 0),
                    negocios_sin_monto: Number(group.negocios_sin_monto || 0),
                    carreras: Number(group.carreras || 0)
                })) : [],
                careers: Array.isArray(report.careers) ? report.careers.map(career => ({
                    carrera: career.carrera || "Sin carrera/arancel asociado",
                    grupo: career.grupo || "",
                    grupo_label: career.grupo_label || career.grupo || "Sin grupo",
                    visible: career.visible,
                    arancel_unitario: Number(career.arancel_unitario || 0),
                    matriculados: Number(career.matriculados || 0),
                    arancel_total: Number(career.arancel_total || 0),
                    monto_real_total: Number(career.monto_real_total || 0),
                    diferencia_total: Number(career.diferencia_total || 0),
                    arancel_sin_monto_total: Number(career.arancel_sin_monto_total || 0),
                    negocios_con_monto: Number(career.negocios_con_monto || 0),
                    negocios_sin_monto: Number(career.negocios_sin_monto || 0),
                    negocios_sin_monto_detalle: Array.isArray(career.negocios_sin_monto_detalle)
                        ? career.negocios_sin_monto_detalle.map(deal => ({
                            id: String(deal.id || ""),
                            nombre: deal.nombre || `Negocio ${deal.id || ""}`,
                            hubspot_url: deal.hubspot_url || ""
                        }))
                        : [],
                    con_arancel: Boolean(career.con_arancel)
                })) : []
            };
        },
        normalizeLeadQualificationBreakdown(value) {
            const breakdown = value || {};

            return {
                stage_label: breakdown.stage_label || "Asignación Coordinación",
                total: Number(breakdown.total || 0),
                teams: Array.isArray(breakdown.teams) ? breakdown.teams.map(team => ({
                    team: team.team || "Sin equipo",
                    total: Number(team.total || 0)
                })) : [],
                owners: Array.isArray(breakdown.owners) ? breakdown.owners.map(owner => ({
                    owner_id: owner.owner_id || "",
                    owner_name: this.normalizeOwnerName(owner.owner_name),
                    team: owner.team || "Sin equipo",
                    total: Number(owner.total || 0)
                })) : []
            };
        },
        normalizeOwnerName(value) {
            const normalized = String(value || "Sin propietario").replace(/\s+/g, " ").trim() || "Sin propietario";

            return normalized.toLocaleUpperCase("es-CL");
        },
        usarDesgloseInicialCalificacionLeads() {
            const initialBreakdown = this.normalizeLeadQualificationBreakdown(this.leadQualificationReport.assignment_team_breakdown);
            this.leadQualificationSelectedStage = initialBreakdown.stage_label || "Asignación Coordinación";
            this.leadQualificationBreakdown = initialBreakdown;
        },
        esEtapaCalificacionSeleccionada(stageLabel) {
            return String(this.leadQualificationSelectedStage || "") === String(stageLabel || "");
        },
        async seleccionarEtapaCalificacionLeads(stageLabel) {
            if (!stageLabel || this.cargandoDesgloseCalificacionLeads) {
                return;
            }

            this.leadQualificationSelectedStage = stageLabel;
            this.cargandoDesgloseCalificacionLeads = true;
            this.error = "";

            try {
                const { data } = await axios.get("/api/dashboard/advance/lead-qualification-breakdown", {
                    params: {
                        periodo: this.leadQualificationPeriod,
                        report_pipeline: this.leadQualificationProgram,
                        stage_label: stageLabel
                    }
                });

                this.leadQualificationBreakdown = this.normalizeLeadQualificationBreakdown(data.breakdown);
                this.leadQualificationSelectedStage = this.leadQualificationBreakdown.stage_label || stageLabel;
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudo cargar el desglose seleccionado.";
            } finally {
                this.cargandoDesgloseCalificacionLeads = false;
            }
        },
        async exportarExcel() {
            if (!this.validarRangoFechas()) {
                return;
            }

            if (!this.meta.total) {
                this.error = "No hay resultados para exportar con los filtros seleccionados.";
                return;
            }

            this.exportando = true;
            this.error = "";

            try {
                const response = await axios.get("/api/dashboard/advance/export", {
                    params: this.parametrosConsulta(),
                    responseType: "blob"
                });
                const blob = response.data instanceof Blob
                    ? response.data
                    : new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `metricas-advance-${this.filtros.desde}-${this.filtros.hasta}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudo exportar la tabla a Excel.";
            } finally {
                this.exportando = false;
            }
        },
        async actualizarDesdeHubSpot() {
            if (this.isDirector) {
                return;
            }

            if (this.sincronizando || this.sincronizacionBloqueada()) {
                return;
            }

            this.sincronizando = true;
            this.error = "";

            try {
                const { data } = await axios.post("/api/dashboard/advance/sync", {
                    periodo: this.reportPeriod || this.advanceReport.periodo,
                    desde: this.filtros.desde
                });

                this.sync = this.normalizeSyncStatus(data.status || null);
                await this.monitorearSincronizacion();
            } catch (error) {
                if (error?.response?.data?.status) {
                    this.sync = this.normalizeSyncStatus(error.response.data.status);

                    if (this.sync.current_run && ["queued", "running"].includes(this.sync.current_run.status)) {
                        await this.monitorearSincronizacion();
                        return;
                    }
                }
                this.error = error?.response?.data?.message || "No se pudo actualizar la información desde HubSpot.";
            } finally {
                if (!this.syncPolling) {
                    this.sincronizando = false;
                }
            }
        },
        async actualizarMovimientosDia() {
            if (this.isDirector) {
                return;
            }

            if (this.actualizandoMovimientosDia || !this.sync || this.sync.can_quick_refresh_today !== true) {
                return;
            }

            this.actualizandoMovimientosDia = true;
            this.error = "";
            this.metasMensaje = "";

            try {
                const { data } = await axios.post("/api/dashboard/advance/quick-refresh", {
                    periodo: this.reportPeriod || this.advanceReport.periodo,
                    report_pipeline: this.reportPipeline || this.advanceReport.report_pipeline || "advance",
                    lead_qualification_program: this.leadQualificationProgram || "advance"
                });

                this.advanceReport = this.normalizeAdvanceReport(data.advance_report);
                this.leadQualificationReport = this.normalizeLeadQualificationReport(data.lead_qualification_report);
                this.sync = this.normalizeSyncStatus(data.sync || null);
                this.reportPeriod = this.advanceReport.periodo || this.reportPeriod;
                this.leadQualificationPeriod = this.leadQualificationReport.periodo || this.leadQualificationPeriod;
                this.leadQualificationProgram = this.leadQualificationReport.lead_qualification_program || this.leadQualificationProgram;
                this.usarDesgloseInicialCalificacionLeads();

                await this.cargarResultados(this.meta.current_page || 1);
                await this.cargarArancelMatriculados();
                this.metasMensaje = `${data.message || "Movimientos del día actualizados."} HubSpot: ${this.formatNumber(data.total_hubspot || 0)} · guardados: ${this.formatNumber(data.total_guardados || 0)}.`;
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudieron actualizar los movimientos del día desde HubSpot.";
            } finally {
                this.actualizandoMovimientosDia = false;
            }
        },
        async monitorearSincronizacion() {
            if (this.syncPolling) {
                return;
            }

            this.syncPolling = true;
            this.sincronizando = true;
            this.error = "";

            try {
                for (let intento = 0; intento < 360; intento++) {
                    await new Promise(resolve => {
                        this.syncPollTimer = window.setTimeout(resolve, 5000);
                    });
                    this.syncPollTimer = null;

                    const { data } = await axios.get("/api/dashboard/advance/sync-status", {
                        params: {
                            periodo: this.reportPeriod || this.advanceReport.periodo
                        }
                    });
                    this.sync = this.normalizeSyncStatus(data);

                    const currentRun = this.sync.current_run;
                    if (!currentRun || !["queued", "running"].includes(currentRun.status)) {
                        if (currentRun && currentRun.status === "succeeded") {
                            await this.cargarResultados(1);
                        } else if (currentRun && currentRun.status === "failed") {
                            this.error = currentRun.error || "No se pudo completar la actualización desde HubSpot.";
                        }

                        return;
                    }
                }

                this.error = "La actualización sigue en curso. Puedes dejar esta página abierta y revisar el estado más tarde.";
            } catch (error) {
                this.error = error?.response?.data?.message || "No se pudo consultar el estado de la actualización.";
            } finally {
                this.syncPollTimer = null;
                this.syncPolling = false;
                this.sincronizando = false;
            }
        },
        aplicarFiltros() {
            this.cargarResultados(1);
        },
        limpiarFiltros() {
            this.filtros = {
                desde: SEARCH_DATE_RANGE.desde,
                hasta: SEARCH_DATE_RANGE.hasta,
                tipoPrograma: "Advance",
                busqueda: "",
                pipelines: [...DEFAULT_PIPELINES],
                sinFiltroPipeline: false,
                perPage: 50
            };
            this.cargarResultados(1);
        },
        formatDate(value) {
            if (!value) {
                return "-";
            }

            const normalized = String(value).replace(" ", "T");
            const date = new Date(`${normalized}Z`);
            if (Number.isNaN(date.getTime())) {
                return value;
            }

            return date.toLocaleString("es-CL", {
                timeZone: "America/Santiago",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        formatHistory(value) {
            if (!value) {
                return "-";
            }

            try {
                const history = Array.isArray(value) ? value : JSON.parse(value);
                return Array.isArray(history) && history.length ? history.join(" · ") : "-";
            } catch (e) {
                return value;
            }
        },
        displayValue(value) {
            return value === null || value === undefined || value === "" ? "-" : value;
        },
        normalizeSummary(value, meta) {
            const summary = value || {};
            const fallbackTotal = meta && meta.total ? meta.total : 0;

            return {
                total: Number(summary.total || fallbackTotal || 0),
                periodos: Array.isArray(summary.periods) ? summary.periods.map(periodo => ({
                    periodo: periodo.periodo || "Sin período",
                    total: Number(periodo.total || 0)
                })) : []
            };
        },
        normalizeConversion(value) {
            const conversion = value || {};
            const overall = conversion.overall || {};
            const paidSearch = conversion.paid_search || {};

            return {
                matriculatedStage: conversion.matriculated_stage || "Matriculado",
                overall: {
                    total: Number(overall.total || 0),
                    matriculados: Number(overall.matriculados || 0),
                    conversionRate: Number(overall.conversion_rate || 0)
                },
                paidSearch: {
                    source: paidSearch.source || "Búsqueda de pago",
                    total: Number(paidSearch.total || 0),
                    matriculados: Number(paidSearch.matriculados || 0),
                    conversionRate: Number(paidSearch.conversion_rate || 0)
                },
                sources: Array.isArray(conversion.sources) ? conversion.sources.map(source => ({
                    ...source,
                    total: Number(source.total || 0),
                    matriculados: Number(source.matriculados || 0),
                    conversion_rate: Number(source.conversion_rate || 0),
                    career_breakdown: Array.isArray(source.career_breakdown) ? source.career_breakdown.map(career => ({
                        ...career,
                        matriculados: Number(career.matriculados || 0),
                        percentage: Number(career.percentage || 0)
                    })) : [],
                    breakdown: Array.isArray(source.breakdown) ? source.breakdown.map(item => ({
                        ...item,
                        total: Number(item.total || 0),
                        matriculados: Number(item.matriculados || 0),
                        conversion_rate: Number(item.conversion_rate || 0)
                    })) : []
                })) : []
            };
        },
        normalizeAdvanceReport(value) {
            const report = value || {};
            const matriculadosTotal = report.matriculados_total !== undefined
                ? report.matriculados_total
                : (report.matriculados_deals_total !== undefined ? report.matriculados_deals_total : report.matriculados_contactos_total);

            return {
                available: Boolean(report.available),
                report_pipeline: report.report_pipeline || "advance",
                report_pipeline_label: report.report_pipeline_label || "Pipeline Advance",
                report_pipeline_options: Array.isArray(report.report_pipeline_options)
                    ? report.report_pipeline_options.map(option => ({
                        key: option.key || "advance",
                        label: option.label || "Pipeline Advance"
                    }))
                    : [
                        { key: "advance", label: "Pipeline Advance" },
                        { key: "diplomados", label: "Pipeline Diplomados" }
                    ],
                report_period_options: Array.isArray(report.report_period_options) && report.report_period_options.length
                    ? report.report_period_options
                    : [],
                periodo: report.periodo || "",
                periodo_anterior: report.periodo_anterior || "",
                pipeline_id: report.pipeline_id || "",
                source: report.source || "Consulta HubSpot por período",
                status: report.status || "legacy",
                last_sync_status: report.last_sync_status || "",
                error: report.error || null,
                as_of: report.as_of || null,
                synced_at: report.synced_at || null,
                total_deals_con_carrera: Number(report.total_deals_con_carrera || 0),
                matriculados_total: Number(matriculadosTotal || 0),
                matriculados_contactos_total: Number(report.matriculados_contactos_total || 0),
                metas_comerciales: {
                    meta_total: Number(report.metas_comerciales && report.metas_comerciales.meta_total || 0),
                    matriculados_total: Number(report.metas_comerciales && report.metas_comerciales.matriculados_total || matriculadosTotal || 0),
                    avance_porcentaje: Number(report.metas_comerciales && report.metas_comerciales.avance_porcentaje || 0)
                },
                stages: Array.isArray(report.stages) ? report.stages.map(stage => ({
                    label: stage.label || "Sin etapa",
                    total: Number(stage.total || 0)
                })) : [],
                matriculados_por_carrera: Array.isArray(report.matriculados_por_carrera)
                    ? this.sortByRateDesc(report.matriculados_por_carrera.map(career => ({
                        carrera: career.carrera || "Sin carrera",
                        facultad: career.facultad || "",
                        modalidad: career.modalidad || "Advance",
                        hidden: Boolean(career.hidden),
                        matriculados_periodo_anterior: Number(career.matriculados_periodo_anterior || 0),
                        meta: Number(career.meta || 0),
                        total: Number(career.total || 0),
                        avance_porcentaje: Number(career.avance_porcentaje || 0)
                    })), "avance_porcentaje", "total", "carrera")
                    : []
            };
        },
        normalizeLeadQualificationReport(value) {
            const report = value || {};
            const assignmentBreakdown = report.assignment_team_breakdown || {};

            return {
                available: Boolean(report.available),
                report_period_options: Array.isArray(report.report_period_options) && report.report_period_options.length
                    ? report.report_period_options
                    : [],
                lead_qualification_program: report.lead_qualification_program || "advance",
                lead_qualification_program_label: report.lead_qualification_program_label || "Advance",
                lead_qualification_program_options: Array.isArray(report.lead_qualification_program_options) && report.lead_qualification_program_options.length
                    ? report.lead_qualification_program_options
                    : [
                        { key: "advance", label: "Advance" },
                        { key: "diplomados", label: "Diplomados" },
                        { key: "postgrado", label: "Magíster" }
                    ],
                tipo_programa: report.tipo_programa || "Advance",
                periodo: report.periodo || "",
                pipeline_id: report.pipeline_id || "",
                pipeline_label: report.pipeline_label || "Calificación Leads",
                source: report.source || "Consulta HubSpot por período",
                as_of: report.as_of || null,
                synced_at: report.synced_at || null,
                total_deals: Number(report.total_deals || 0),
                stages: Array.isArray(report.stages) ? report.stages.map(stage => ({
                    label: stage.label || "Sin etapa",
                    total: Number(stage.total || 0)
                })) : [],
                assignment_team_breakdown: {
                    stage_label: assignmentBreakdown.stage_label || "Asignación Coordinación",
                    total: Number(assignmentBreakdown.total || 0),
                    teams: Array.isArray(assignmentBreakdown.teams) ? assignmentBreakdown.teams.map(team => ({
                        team: team.team || "Sin equipo",
                        total: Number(team.total || 0)
                    })) : [],
                    owners: Array.isArray(assignmentBreakdown.owners) ? assignmentBreakdown.owners.map(owner => ({
                        owner_id: owner.owner_id || "",
                        owner_name: this.normalizeOwnerName(owner.owner_name),
                        team: owner.team || "Sin equipo",
                        total: Number(owner.total || 0)
                    })) : []
                }
            };
        },
        normalizeSyncStatus(value) {
            const sync = value || {};
            const currentRun = sync.current_run || null;

            return {
                periodo: sync.periodo || "",
                today: sync.today || "",
                can_sync_today: sync.can_sync_today !== false,
                can_trigger_sync: sync.can_trigger_sync === true,
                can_quick_refresh_today: sync.can_quick_refresh_today === true,
                current_run: currentRun,
                last_successful_run: sync.last_successful_run || null,
                cache: sync.cache || null,
                panel: sync.panel || null,
                advance_report: sync.advance_report || null
            };
        },
        sincronizacionBloqueada() {
            const currentRun = this.sync && this.sync.current_run;
            if (!this.sync || this.sync.can_trigger_sync !== true) {
                return true;
            }

            return Boolean(currentRun && ["queued", "running"].includes(currentRun.status))
                || Boolean(currentRun && currentRun.status === "succeeded" && !this.sync.can_sync_today);
        },
        sincronizacionLabel() {
            if (!this.sync || this.sync.can_trigger_sync !== true) {
                return "Solo SuperAdmin";
            }

            if (this.sincronizando) {
                const percent = this.syncProgressPercent;
                return percent > 0 ? `Actualizando (${percent}%)...` : "Actualizando ambos reportes...";
            }

            const currentRun = this.sync && this.sync.current_run;
            if (currentRun && currentRun.status === "succeeded") {
                return this.sync.can_sync_today ? "Actualizar nuevamente" : "Actualizados hoy";
            }

            if (currentRun && ["queued", "running"].includes(currentRun.status)) {
                const percent = Number(currentRun.progress_percent || 0);
                return percent > 0 ? `Actualización en curso (${percent}%)` : "Actualización en curso";
            }

            return "Actualizar ambos reportes";
        },
        formatNumber(value) {
            return Number(value || 0).toLocaleString("es-CL");
        },
        formatCurrency(value) {
            return new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: "CLP",
                maximumFractionDigits: 0
            }).format(Number(value || 0));
        },
        formatDashboardStageLabel(label) {
            if (label === "Asignación Coordinación") {
                return "Asig. Cordinación";
            }
            if (label === "Solicitud Documentos") {
                return "Sol. Documentos";
            }

            return label;
        },
        formatPercentage(value) {
            return `${Number(value || 0).toLocaleString("es-CL", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}%`;
        },
        formatGoalPercentage(value) {
            return `${Number(value || 0).toLocaleString("es-CL", {
                maximumFractionDigits: 0
            })}%`;
        },
        calculateGoalProgress(matriculados, meta) {
            const goal = Number(meta || 0);
            if (goal <= 0) {
                return 0;
            }

            return (Number(matriculados || 0) / goal) * 100;
        },
        sortByRateDesc(items, rateKey, volumeKey = "total", labelKey = "label") {
            return [...items].sort((left, right) => {
                const rateDiff = Number(right[rateKey] || 0) - Number(left[rateKey] || 0);
                if (rateDiff !== 0) {
                    return rateDiff;
                }

                const volumeDiff = Number(right[volumeKey] || 0) - Number(left[volumeKey] || 0);
                if (volumeDiff !== 0) {
                    return volumeDiff;
                }

                return String(left[labelKey] || "").localeCompare(String(right[labelKey] || ""), "es");
            });
        },
        calculateGrowthPercentage(current, previous) {
            const previousValue = Number(previous || 0);
            if (previousValue <= 0) {
                return 0;
            }

            return ((Number(current || 0) - previousValue) / previousValue) * 100;
        },
        async toggleCareerVisibility(career) {
            if (this.guardandoMetas) {
                return;
            }

            const wasHidden = Boolean(career.hidden);
            career.hidden = !wasHidden;
            this.metasMensaje = "";

            const saved = await this.guardarMetasComerciales();
            if (!saved) {
                career.hidden = wasHidden;
            }
        },
        isPaidSearch(source) {
            return source && source.source_value === "PAID_SEARCH";
        },
        isExpandableSource(source) {
            return Boolean(source && Array.isArray(source.breakdown) && source.breakdown.length);
        },
        isSourceExpanded(source) {
            return this.isExpandableSource(source) && Boolean(this.expandedBreakdowns[source.source_value]);
        },
        isSourceSelected(source) {
            return source && source.source_value === this.fuenteSeleccionada;
        },
        selectSource(source) {
            if (!source) {
                return;
            }

            const alreadySelected = this.isSourceSelected(source);
            this.fuenteSeleccionada = alreadySelected ? null : source.source_value;

            if (this.isExpandableSource(source)) {
                this.$set(this.expandedBreakdowns, source.source_value, !alreadySelected);
            }
        }
    },
    beforeDestroy() {
        if (this.syncPollTimer) {
            window.clearTimeout(this.syncPollTimer);
            this.syncPollTimer = null;
        }
    }
};
</script>

<template>
    <component :is="layoutComponent" :class="{ 'dashboard-advance-embedded': embedded }">
        <PageHeader v-if="!embedded" :title="title" :items="items" />

        <div v-if="!isDirector" class="row mb-3">
            <div class="col-12">
                <div class="card advance-sync-toolbar border-0 shadow-sm">
                    <div class="card-body d-flex flex-wrap align-items-center justify-content-between">
                        <div class="d-flex align-items-start">
                            <i class="bx bx-refresh advance-sync-toolbar-icon mr-3"></i>
                            <div>
                                <h5 class="mb-1">Actualización diaria de HubSpot</h5>
                                <p class="text-muted mb-1">Actualiza la caché general y el conjunto exacto del panel Advance + Paid Search.</p>
                                <small class="text-muted">Actualización automática diaria a las 05:00 · filtros del panel: pipelines actuales, tipo Advance y fuente Paid Search.</small>
                                <div class="small text-muted mt-1">
                                    <span v-if="advanceReport.synced_at">Reporte: {{ formatDate(advanceReport.synced_at) }} · hasta {{ formatDate(advanceReport.as_of) }}</span>
                                    <span v-if="sync && sync.cache && sync.cache.synced_at" :class="{ 'ml-2': advanceReport.synced_at }">
                                        Leads: {{ sync.cache.mode === 'incremental' ? 'incremental' : 'completo' }} · hasta {{ formatDate(sync.cache.last_modified_to || sync.cache.to_date) }}
                                    </span>
                                    <span v-if="sync && sync.panel && sync.panel.synced_at" class="d-block">
                                        Panel HubSpot: {{ formatNumber(sync.panel.total_deals) }} negocios exactos · {{ sync.panel.desde }} a {{ formatDate(sync.panel.hasta) }}
                                    </span>
                                </div>
                                <div v-if="syncProgressVisible" class="advance-sync-progress mt-3">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <strong>{{ syncProgressStage }}</strong>
                                        <strong>{{ syncProgressPercent }}%</strong>
                                    </div>
                                    <div class="progress advance-sync-progress-bar">
                                        <div
                                            class="progress-bar progress-bar-striped progress-bar-animated"
                                            role="progressbar"
                                            :style="{ width: `${syncProgressPercent}%` }"
                                            :aria-valuenow="syncProgressPercent"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    </div>
                                    <div class="small text-muted mt-1">
                                        <span>{{ syncRun.progress_message || "Procesando información de HubSpot..." }}</span>
                                        <span v-if="syncProgressCounter" class="ml-2">({{ syncProgressCounter }})</span>
                                        <span v-if="syncRun.last_activity_at" class="d-block">
                                            Última actividad: {{ formatDate(syncRun.last_activity_at) }}
                                        </span>
                                    </div>
                                    <div v-if="syncRun.progress_is_stale && ['queued', 'running'].includes(syncRun.status)" class="alert alert-warning py-2 px-3 mt-2 mb-0 small">
                                        <i class="bx bx-time-five mr-1"></i>
                                        No se registran novedades hace varios minutos. La consulta puede estar esperando respuesta de HubSpot o requerir un reintento.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-3 mt-md-0 ml-md-3 text-md-right">
                            <button
                                type="button"
                                class="btn btn-outline-primary mr-md-2 mb-2 mb-md-0"
                                :disabled="actualizandoMovimientosDia || sincronizando || !sync || sync.can_quick_refresh_today !== true"
                                @click="actualizarMovimientosDia"
                            >
                                <i class="bx mr-1" :class="actualizandoMovimientosDia ? 'bx-loader-alt bx-spin' : 'bx-time-five'"></i>
                                {{ actualizandoMovimientosDia ? "Actualizando hoy..." : "Movimientos de hoy" }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="advanceReport.available" class="row mb-3">
            <div class="col-12">
                <div class="card advance-period-report-card border-0 shadow-sm">
                    <div class="card-header advance-period-report-header d-flex flex-wrap justify-content-between align-items-center">
                        <div>
                            <h4 class="text-white mb-1">Reporte HubSpot por período</h4>
                            <p class="text-white-50 mb-0">Snapshot de la consulta HubSpot, independiente de la caché general de leads.</p>
                        </div>
                        <div class="advance-period-report-period mt-2 mt-md-0">
                            <small>Período</small>
                            <select
                                v-model="reportPeriod"
                                class="form-control form-control-sm advance-period-report-select"
                                :disabled="cargandoReportePeriodo"
                                @change="cambiarPeriodoReporte"
                            >
                                <option
                                    v-for="periodo in advanceReport.report_period_options"
                                    :key="periodo"
                                    :value="periodo"
                                >{{ periodo }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="card-body">
                        <div v-if="advanceReport.error" class="alert alert-warning py-2">
                            <i class="bx bx-error-circle mr-1"></i>
                            Último intento fallido: {{ advanceReport.error }}. Puedes reintentar la actualización.
                        </div>
                        <div class="row">
                            <div class="col-12 mb-4">
                                <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                                    <div>
                                        <h5 class="mb-1">Negocios por etapa</h5>
                                        <small class="text-muted">{{ formatNumber(advanceReport.total_deals_con_carrera) }} negocios con carrera informada.</small>
                                    </div>
                                    <div class="advance-report-pipeline-control mt-2 mt-md-0">
                                        <i v-if="cargandoReportePeriodo" class="bx bx-loader-alt bx-spin mr-1"></i>
                                        <select
                                            v-model="reportPipeline"
                                            class="custom-select custom-select-sm"
                                            :disabled="cargandoReportePeriodo"
                                            @change="cambiarPipelineReporte"
                                        >
                                            <option
                                                v-for="option in advanceReport.report_pipeline_options"
                                                :key="option.key"
                                                :value="option.key"
                                            >
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="advance-report-stage-grid">
                                    <div v-for="stage in advanceReport.stages" :key="stage.label" class="advance-report-stage-item">
                                        <div class="advance-report-stage" :class="{ 'advance-report-stage-matriculado': stage.label === 'Matriculado' }">
                                            <span>{{ formatDashboardStageLabel(stage.label) }}</span>
                                            <strong>{{ formatNumber(stage.total) }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                                    <div>
                                        <h5 class="mb-1">Metas comerciales por carrera</h5>
                                        <small class="text-muted">
                                            Meta total: {{ formatNumber(commercialGoalTotal) }} ·
                                            Matriculados: {{ formatNumber(commercialGoalMatriculadosTotal) }} ·
                                            Avance: {{ formatGoalPercentage(commercialGoalProgressTotal) }} ·
                                            Visibilidad: {{ reportPeriod || advanceReport.periodo }}
                                        </small>
                                    </div>
                                    <button
                                        v-if="!isDirector"
                                        type="button"
                                        class="btn btn-sm btn-primary mt-2 mt-md-0"
                                        :disabled="guardandoMetas"
                                        @click="guardarMetasComerciales"
                                    >
                                        <i class="bx mr-1" :class="guardandoMetas ? 'bx-loader-alt bx-spin' : 'bx-save'"></i>
                                        {{ guardandoMetas ? "Guardando..." : "Guardar datos" }}
                                    </button>
                                </div>
                                <div v-if="metasMensaje" class="alert alert-success py-2 mb-2">
                                    {{ metasMensaje }}
                                </div>
                                <div v-if="!isDirector" class="advance-career-visibility-toolbar d-flex flex-wrap align-items-center justify-content-between mb-2">
                                    <div class="d-flex align-items-center mb-2 mb-md-0">
                                        <label class="mb-0 mr-2 small text-muted" for="career-visibility-filter">Carreras</label>
                                        <select
                                            id="career-visibility-filter"
                                            v-model="careerVisibilityFilter"
                                            class="form-control form-control-sm advance-career-visibility-select"
                                        >
                                            <option value="visible">Visibles</option>
                                            <option value="hidden">Ocultas</option>
                                            <option value="all">Todas</option>
                                        </select>
                                    </div>
                                    <small class="text-muted">
                                        Mostrando {{ formatNumber(visibleCommercialCareers.length) }} de {{ formatNumber(advanceReport.matriculados_por_carrera.length) }} · Ocultas: {{ formatNumber(hiddenCommercialCareersCount) }}
                                    </small>
                                </div>
                                <div class="table-responsive advance-report-career-table-wrapper">
                                    <table class="table table-sm table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th class="advance-report-goal-cell-sm">Facultad</th>
                                                <th>Carrera</th>
                                                <th class="advance-report-previous-period-col text-right">Matr. período anterior</th>
                                                <th class="advance-report-goal-cell-xs text-right">Meta</th>
                                                <th class="advance-report-growth-col text-right">Crec. meta</th>
                                                <th class="text-right">Matriculados</th>
                                                <th class="text-right">%</th>
                                                <th v-if="!isDirector" class="advance-report-action-col text-right">Acción</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="career in visibleCommercialCareers" :key="career.carrera" :class="{ 'advance-report-career-hidden': career.hidden }">
                                                <td class="advance-report-goal-cell-sm">
                                                    <span v-if="isDirector">{{ career.facultad || '-' }}</span>
                                                    <input
                                                        v-else
                                                        v-model.trim="career.facultad"
                                                        type="text"
                                                        class="form-control form-control-sm"
                                                        placeholder="Facultad"
                                                    >
                                                </td>
                                                <td>{{ career.carrera }}</td>
                                                <td class="text-right font-weight-bold">{{ formatNumber(career.matriculados_periodo_anterior) }}</td>
                                                <td class="advance-report-goal-cell-xs">
                                                    <span v-if="isDirector" class="d-block text-right">{{ formatNumber(career.meta) }}</span>
                                                    <input
                                                        v-else
                                                        v-model.number="career.meta"
                                                        type="number"
                                                        min="0"
                                                        step="1"
                                                        class="form-control form-control-sm text-right"
                                                    >
                                                </td>
                                                <td class="text-right font-weight-bold">{{ formatGoalPercentage(calculateGrowthPercentage(career.meta, career.matriculados_periodo_anterior)) }}</td>
                                                <td class="text-right font-weight-bold">{{ formatNumber(career.total) }}</td>
                                                <td class="text-right font-weight-bold">{{ formatGoalPercentage(calculateGoalProgress(career.total, career.meta)) }}</td>
                                                <td v-if="!isDirector" class="advance-report-action-col text-right">
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm"
                                                        :class="career.hidden ? 'btn-outline-primary' : 'btn-outline-secondary'"
                                                        :disabled="guardandoMetas"
                                                        :title="career.hidden ? `Mostrar carrera en ${reportPeriod || advanceReport.periodo}` : `Ocultar carrera en ${reportPeriod || advanceReport.periodo}`"
                                                        :aria-label="career.hidden ? `Mostrar carrera en ${reportPeriod || advanceReport.periodo}` : `Ocultar carrera en ${reportPeriod || advanceReport.periodo}`"
                                                        @click="toggleCareerVisibility(career)"
                                                    >
                                                        <i class="bx" :class="career.hidden ? 'bx-show' : 'bx-hide'"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr v-if="visibleCommercialCareers.length === 0">
                                                <td :colspan="isDirector ? 7 : 8" class="text-center text-muted py-3">No hay carreras visibles.</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="2" class="text-right">Total</th>
                                                <th class="text-right">{{ formatNumber(previousPeriodMatriculadosTotal) }}</th>
                                                <th class="text-right">{{ formatNumber(commercialGoalTotal) }}</th>
                                                <th class="text-right">{{ formatGoalPercentage(commercialGoalGrowthTotal) }}</th>
                                                <th class="text-right">{{ formatNumber(commercialGoalMatriculadosTotal) }}</th>
                                                <th class="text-right">{{ formatGoalPercentage(commercialGoalProgressTotal) }}</th>
                                                <th v-if="!isDirector"></th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isDirector && leadQualificationReport.available" class="row mb-3">
            <div class="col-12">
                <div class="card advance-period-report-card border-0 shadow-sm">
                    <div class="card-header advance-lead-qualification-header d-flex flex-wrap justify-content-between align-items-center">
                        <div>
                            <h4 class="text-white mb-1">Calificación Leads por período</h4>
                            <p class="text-white-50 mb-0">Pipeline separado con etapas propias de calificación.</p>
                        </div>
                        <div class="advance-period-report-period mt-2 mt-md-0">
                            <small>Período</small>
                            <select
                                v-model="leadQualificationPeriod"
                                class="form-control form-control-sm advance-period-report-select"
                                :disabled="cargandoCalificacionLeads"
                                @change="cambiarPeriodoCalificacionLeads"
                            >
                                <option
                                    v-for="periodo in leadQualificationReport.report_period_options"
                                    :key="periodo"
                                    :value="periodo"
                                >{{ periodo }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                            <div>
                                <h5 class="mb-1">Negocios por etapa</h5>
                                <small class="text-muted">
                                    {{ leadQualificationReport.pipeline_label }} · {{ leadQualificationReport.lead_qualification_program_label }} · {{ formatNumber(leadQualificationReport.total_deals) }} negocios.
                                </small>
                            </div>
                            <div class="d-flex flex-column align-items-md-end mt-2 mt-md-0">
                                <div class="advance-report-pipeline-control">
                                    <i v-if="cargandoCalificacionLeads" class="bx bx-loader-alt bx-spin mr-1"></i>
                                    <select
                                        v-model="leadQualificationProgram"
                                        class="custom-select custom-select-sm"
                                        :disabled="cargandoCalificacionLeads"
                                        @change="cambiarProgramaCalificacionLeads"
                                    >
                                        <option
                                            v-for="option in leadQualificationReport.lead_qualification_program_options"
                                            :key="option.key"
                                            :value="option.key"
                                        >
                                            {{ option.label }}
                                        </option>
                                    </select>
                                </div>
                                <small v-if="leadQualificationReport.synced_at" class="text-muted mt-2">
                                    Reporte: {{ formatDate(leadQualificationReport.synced_at) }} · hasta {{ formatDate(leadQualificationReport.as_of) }}
                                </small>
                            </div>
                        </div>
                        <div class="advance-report-stage-grid advance-lead-qualification-grid">
                            <div v-for="stage in leadQualificationStageCards" :key="stage.label" class="advance-report-stage-item">
                                <button
                                    type="button"
                                    class="advance-report-stage advance-lead-qualification-stage advance-lead-qualification-stage-button"
                                    :class="{ 'advance-lead-qualification-stage-active': esEtapaCalificacionSeleccionada(stage.label) }"
                                    :disabled="cargandoDesgloseCalificacionLeads"
                                    @click="seleccionarEtapaCalificacionLeads(stage.label)"
                                >
                                    <span>{{ formatDashboardStageLabel(stage.label) }}</span>
                                    <strong>{{ formatNumber(stage.total) }}</strong>
                                </button>
                            </div>
                        </div>
                        <div v-if="leadQualificationBreakdown.teams.length" class="advance-assignment-breakdown mt-4">
                            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                                <div>
                                    <h5 class="mb-1">Distribución por equipo y responsable</h5>
                                    <small class="text-muted">
                                        {{ leadQualificationBreakdown.stage_label }} · {{ leadQualificationReport.lead_qualification_program_label }} · {{ formatNumber(leadQualificationBreakdown.total) }} negocios.
                                    </small>
                                </div>
                                <i v-if="cargandoDesgloseCalificacionLeads" class="bx bx-loader-alt bx-spin text-muted mt-2 mt-md-0"></i>
                            </div>
                            <div v-if="leadQualificationBreakdown.owners.length" class="table-responsive advance-assignment-owner-table">
                                <table class="table table-sm table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th>Responsable</th>
                                            <th>Equipo</th>
                                            <th class="text-right">Negocios</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="owner in leadQualificationBreakdown.owners"
                                            :key="owner.owner_id || owner.owner_name"
                                        >
                                            <td>{{ owner.owner_name }}</td>
                                            <td>{{ owner.team }}</td>
                                            <td class="text-right font-weight-bold">{{ formatNumber(owner.total) }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="2">Total</th>
                                            <th class="text-right">{{ formatNumber(leadQualificationBreakdownOwnersTotal) }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!isDirector && hasRestrictedAccess" class="row mb-3">
            <div class="col-12">
                <div class="card tuition-report-card border-0 shadow-sm">
                    <div class="card-header tuition-report-header d-flex flex-wrap justify-content-between align-items-center">
                        <div>
                            <h4 class="text-white mb-1">Arancel de matriculados por carrera</h4>
                            <p class="text-white-50 mb-0">Proyección bruta: matriculados × arancel vigente del catálogo HubSpot.</p>
                        </div>
                        <div class="d-flex flex-wrap tuition-report-filters mt-2 mt-lg-0">
                            <label class="mb-0 mr-2">
                                <small>Período</small>
                                <select
                                    v-model="leadQualificationPeriod"
                                    class="custom-select custom-select-sm"
                                    :disabled="cargandoCalificacionLeads || cargandoArancelMatriculados"
                                    @change="cambiarPeriodoCalificacionLeads"
                                >
                                    <option
                                        v-for="periodo in leadQualificationReport.report_period_options"
                                        :key="periodo"
                                        :value="periodo"
                                    >{{ periodo }}</option>
                                </select>
                            </label>
                            <label class="mb-0 mr-2">
                                <small>Grupo</small>
                                <select v-model="tuitionGroupFilter" class="custom-select custom-select-sm" :disabled="cargandoArancelMatriculados" @change="cargarArancelMatriculados">
                                    <option value="all">Todos</option>
                                    <option value="advance">Advance</option>
                                    <option value="pregrado">Pregrado</option>
                                    <option value="postgrado">Postgrado</option>
                                </select>
                            </label>
                            <label class="mb-0">
                                <small>Visible en simulador</small>
                                <select v-model="tuitionVisibilityFilter" class="custom-select custom-select-sm" :disabled="cargandoArancelMatriculados" @change="cargarArancelMatriculados">
                                    <option value="visible">Sí</option>
                                    <option value="hidden">No</option>
                                    <option value="all">Todos</option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="tuition-summary-main mb-3">
                            <div><small>Matriculados con arancel</small><strong>{{ formatNumber(matriculatedTuitionReport.matriculados) }}</strong></div>
                            <div><small>Arancel total sin descuentos</small><strong>{{ formatCurrency(matriculatedTuitionReport.arancel_total) }}</strong></div>
                            <div class="tuition-money"><small>Monto real pagado</small><strong>{{ formatCurrency(matriculatedTuitionReport.monto_real_total) }}</strong></div>
                            <div><small>Diferencia / descuentos</small><strong>{{ formatCurrency(matriculatedTuitionReport.diferencia_total) }}</strong></div>
                            <div>
                                <small>Arancel sin monto informado</small>
                                <strong>{{ formatCurrency(matriculatedTuitionReport.arancel_sin_monto_total) }}</strong>
                                <button
                                    v-if="missingTuitionDeals.length"
                                    type="button"
                                    class="btn btn-link tuition-missing-modal-link"
                                    @click="showMissingTuitionDealsModal = true"
                                >Ver {{ formatNumber(missingTuitionDeals.length) }} matrículas en HubSpot</button>
                            </div>
                            <i v-if="cargandoArancelMatriculados" class="bx bx-loader-alt bx-spin tuition-loader"></i>
                        </div>

                        <div class="tuition-group-grid mb-4">
                            <div v-for="group in matriculatedTuitionReport.groups" :key="group.grupo" class="tuition-group-card">
                                <span>{{ group.label }}</span>
                                <strong>{{ formatCurrency(group.monto_real_total) }}</strong>
                                <small>Real pagado · {{ formatNumber(group.negocios_con_monto) }} negocios con monto</small>
                                <small>Sin descuentos: {{ formatCurrency(group.arancel_total) }}</small>
                                <small>Diferencia: {{ formatCurrency(group.diferencia_total) }}</small>
                                <small>Sin monto: {{ formatCurrency(group.arancel_sin_monto_total) }} · {{ formatNumber(group.negocios_sin_monto) }} negocios</small>
                            </div>
                        </div>

                        <div class="table-responsive tuition-career-table">
                            <table class="table table-sm table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Carrera / programa</th>
                                        <th v-if="tuitionGroupFilter === 'all'">Grupo</th>
                                        <th class="text-right">Matriculados</th>
                                        <th class="text-right">Arancel unitario sin desc.</th>
                                        <th class="text-right">Total sin desc.</th>
                                        <th class="text-right">Monto real pagado</th>
                                        <th class="text-right">Diferencia</th>
                                        <th class="text-right">Arancel sin monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="career in matriculatedTuitionReport.careers" :key="`${career.grupo}-${career.carrera}-${career.visible}`">
                                        <td>{{ career.carrera }}</td>
                                        <td v-if="tuitionGroupFilter === 'all'"><span class="badge badge-light tuition-group-badge">{{ career.grupo_label }}</span></td>
                                        <td class="text-right">{{ formatNumber(career.matriculados) }}</td>
                                        <td class="text-right">{{ career.con_arancel ? formatCurrency(career.arancel_unitario) : '—' }}</td>
                                        <td class="text-right">{{ career.con_arancel ? formatCurrency(career.arancel_total) : '—' }}</td>
                                        <td class="text-right text-primary">{{ formatCurrency(career.monto_real_total) }}</td>
                                        <td class="text-right">{{ career.con_arancel ? formatCurrency(career.diferencia_total) : '—' }}</td>
                                        <td class="text-right">
                                            <template v-if="career.con_arancel">
                                                {{ `${formatCurrency(career.arancel_sin_monto_total)} (${formatNumber(career.negocios_sin_monto)})` }}
                                            </template>
                                            <template v-else>—</template>
                                        </td>
                                    </tr>
                                    <tr v-if="!cargandoArancelMatriculados && !matriculatedTuitionReport.careers.length">
                                        <td :colspan="tuitionGroupFilter === 'all' ? 8 : 7" class="text-center text-muted py-4">No hay matriculados asociados a productos para estos filtros.</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="matriculatedTuitionReport.careers.length">
                                    <tr>
                                        <td :colspan="tuitionGroupFilter === 'all' ? 2 : 1">Total filtrado</td>
                                        <td class="text-right">{{ formatNumber(matriculatedTuitionReport.matriculados) }}</td>
                                        <td></td>
                                        <td class="text-right">{{ formatCurrency(matriculatedTuitionReport.arancel_total) }}</td>
                                        <td class="text-right">{{ formatCurrency(matriculatedTuitionReport.monto_real_total) }}</td>
                                        <td class="text-right">{{ formatCurrency(matriculatedTuitionReport.diferencia_total) }}</td>
                                        <td class="text-right">{{ formatCurrency(matriculatedTuitionReport.arancel_sin_monto_total) }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <small class="d-block text-muted mt-3">
                            “Diferencia / descuentos” considera solo negocios con monto informado. “Arancel sin monto informado” reúne los negocios cuyo amount está vacío en HubSpot. Ambos valores sumados explican la brecha entre el arancel total y el monto real pagado.
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            v-model="showMissingTuitionDealsModal"
            title="Matrículas sin monto informado"
            size="lg"
            scrollable
            hide-footer
        >
            <p class="text-muted mb-3">
                Negocios matriculados sin <strong>amount</strong> informado en HubSpot para el período y filtros seleccionados.
            </p>
            <div v-if="missingTuitionDeals.length" class="list-group tuition-missing-modal-list">
                <a
                    v-for="deal in missingTuitionDeals"
                    :key="deal.id"
                    :href="deal.hubspot_url"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="list-group-item list-group-item-action"
                >
                    <div class="d-flex justify-content-between align-items-start">
                        <div>
                            <strong>{{ deal.nombre }}</strong>
                            <small class="d-block text-muted">{{ deal.grupo_label }} · {{ deal.carrera }}</small>
                        </div>
                        <span class="badge badge-light ml-3">{{ formatCurrency(deal.arancel) }}</span>
                    </div>
                    <small class="tuition-hubspot-link">Abrir negocio {{ deal.id }} en HubSpot <i class="bx bx-link-external"></i></small>
                </a>
            </div>
            <div v-else class="text-center text-muted py-4">No hay matrículas sin monto para estos filtros.</div>
        </b-modal>

        <div v-if="!isDirector" class="row">
            <div class="col-12">
                <div class="card dashboard-advance-card border-0 shadow-sm">
                    <div class="card-header dashboard-advance-header d-flex justify-content-between align-items-center">
                        <div>
                            <h4 class="text-white mb-1">Leads Advance</h4>
                            <p class="text-white-50 mb-0">Consulta la caché local de negocios sincronizados desde HubSpot.</p>
                        </div>
                        <i class="bx bx-bar-chart-alt-2 dashboard-advance-icon"></i>
                    </div>

                    <div class="card-body">
                        <form @submit.prevent="aplicarFiltros">
                            <div class="row align-items-start">
                                <div class="col-md-3 mb-3">
                                    <label for="dashboard-advance-desde" class="font-weight-bold">Desde</label>
                                    <input
                                        id="dashboard-advance-desde"
                                        v-model="filtros.desde"
                                        type="date"
                                        class="form-control"
                                    >
                                </div>
                                <div class="col-md-3 mb-3">
                                    <label for="dashboard-advance-hasta" class="font-weight-bold">Hasta</label>
                                    <input
                                        id="dashboard-advance-hasta"
                                        v-model="filtros.hasta"
                                        type="date"
                                        class="form-control"
                                    >
                                </div>
                                <div class="col-md-2 mb-3">
                                    <label for="dashboard-advance-tipo" class="font-weight-bold">Tipo de programa</label>
                                    <select id="dashboard-advance-tipo" v-model="filtros.tipoPrograma" class="form-control">
                                        <option value="Advance">Advance</option>
                                        <option value="">Todos</option>
                                    </select>
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label for="dashboard-advance-busqueda" class="font-weight-bold">Buscar</label>
                                    <input
                                        id="dashboard-advance-busqueda"
                                        v-model="filtros.busqueda"
                                        type="search"
                                        class="form-control"
                                        placeholder="ID, negocio, propietario o carrera"
                                    >
                                </div>
                            </div>

                            <div class="row align-items-center">
                                <div class="col-lg-8 mb-3">
                                    <span class="font-weight-bold d-block mb-2">Pipeline histórico</span>
                                    <div class="d-flex flex-wrap">
                                        <label
                                            v-for="pipeline in pipelineOptions"
                                            :key="pipeline"
                                            class="custom-control custom-checkbox mr-4 mb-2"
                                        >
                                            <input
                                                v-model="filtros.pipelines"
                                                :value="pipeline"
                                                type="checkbox"
                                                class="custom-control-input"
                                                :disabled="filtros.sinFiltroPipeline"
                                            >
                                            <span class="custom-control-label">{{ pipeline }}</span>
                                        </label>
                                        <label class="custom-control custom-checkbox mb-2">
                                            <input v-model="filtros.sinFiltroPipeline" type="checkbox" class="custom-control-input">
                                            <span class="custom-control-label">Todos los pipelines</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-lg-4 mb-3 d-flex justify-content-lg-end align-items-end">
                                    <button type="button" class="btn btn-light mr-2" :disabled="cargando" @click="limpiarFiltros">
                                        <i class="bx bx-reset mr-1"></i> Limpiar
                                    </button>
                                    <button type="submit" class="btn btn-primary" :disabled="cargando">
                                        <i class="bx" :class="cargando ? 'bx-loader-alt bx-spin' : 'bx-search'"></i>
                                        {{ cargando ? "Consultando..." : "Consultar" }}
                                    </button>
                                </div>
                            </div>
                        </form>

                        <div v-if="error" class="alert alert-danger mt-2 mb-0">
                            {{ error }}
                        </div>

                        <div v-if="resumenLeads.periodos.length" class="lead-period-summary mt-3 mb-3">
                            <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
                                <div>
                                    <h5 class="mb-1">Leads por período</h5>
                                    <small class="text-muted">Resumen de los leads que coinciden con los filtros y la búsqueda.</small>
                                </div>
                                <strong class="text-primary mt-2 mt-md-0">Total: {{ formatNumber(resumenLeads.total) }}</strong>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-sm table-hover mb-0 lead-period-table">
                                    <thead>
                                        <tr>
                                            <th>Período</th>
                                            <th class="text-right">Cantidad de leads</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><strong>Total general</strong></td>
                                            <td class="text-right font-weight-bold">{{ formatNumber(resumenLeads.total) }}</td>
                                        </tr>
                                        <tr v-for="periodo in resumenLeads.periodos" :key="periodo.periodo">
                                            <td>{{ periodo.periodo }}</td>
                                            <td class="text-right">{{ formatNumber(periodo.total) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="dashboard-advance-summary mt-3 mb-3 d-flex flex-wrap align-items-center justify-content-end">
                            <div class="d-flex flex-wrap align-items-center mt-2 mt-md-0">
                                <button
                                    type="button"
                                    class="btn btn-success btn-sm mr-3"
                                    :disabled="cargando || exportando || !meta.total"
                                    @click="exportarExcel"
                                >
                                    <i class="bx mr-1" :class="exportando ? 'bx-loader-alt bx-spin' : 'bx-spreadsheet'"></i>
                                    {{ exportando ? "Exportando..." : "Exportar Excel" }}
                                </button>
                                <i class="bx bx-database mr-1"></i>
                                <span v-if="cache && cache.synced_at">
                                    Caché local sincronizada {{ formatDate(cache.synced_at) }}
                                    <span v-if="cache.to_date"> · datos hasta {{ formatDate(cache.to_date) }}</span>
                                </span>
                                <span v-else>Caché local sin sincronización registrada</span>
                            </div>
                        </div>

                        <div v-if="conversion.sources.length" class="conversion-breakdown mb-4">
                            <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
                                <div>
                                    <h5 class="mb-1">Conversión por fuente original</h5>
                                    <small class="text-muted">{{ conversion.matriculatedStage }} corresponde a la etapa actual del negocio.</small>
                                </div>
                                <span class="badge badge-soft-primary mt-2 mt-md-0">{{ conversion.sources.length }} fuentes</span>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-sm table-hover mb-0 conversion-table">
                                    <thead>
                                        <tr>
                                            <th>Fuente original</th>
                                            <th class="text-right">Total</th>
                                            <th class="text-right">Matriculados</th>
                                            <th class="text-right">Conversión</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="source in conversion.sources">
                                            <tr
                                                :key="`${source.source_value}-${source.source}`"
                                                :class="{
                                                    'conversion-paid-search': isPaidSearch(source),
                                                    'conversion-source-row': true,
                                                    'conversion-selected-source': isSourceSelected(source)
                                                }"
                                                :aria-expanded="isSourceSelected(source) ? 'true' : 'false'"
                                                role="button"
                                                tabindex="0"
                                                @click="selectSource(source)"
                                                @keydown.enter.prevent="selectSource(source)"
                                            >
                                                <td>
                                                    <i v-if="isExpandableSource(source)" class="bx mr-1" :class="isSourceExpanded(source) ? 'bx-chevron-down' : 'bx-chevron-right'"></i>
                                                    <span>{{ source.source }}</span>
                                                    <small class="text-muted ml-2">
                                                        {{ isSourceSelected(source) ? "Ocultar carreras" : "Ver carreras" }}
                                                        <span v-if="isExpandableSource(source)"> · {{ isSourceExpanded(source) ? "Ocultar desglose" : "Ver desglose" }}</span>
                                                    </small>
                                                </td>
                                                <td class="text-right">{{ formatNumber(source.total) }}</td>
                                                <td class="text-right">{{ formatNumber(source.matriculados) }}</td>
                                                <td class="text-right font-weight-bold">{{ formatPercentage(source.conversion_rate) }}</td>
                                            </tr>
                                            <tr
                                                v-for="breakdown in source.breakdown"
                                                v-if="isExpandableSource(source) && isSourceExpanded(source)"
                                                :key="`${source.source_value}-${breakdown.breakdown}`"
                                                class="conversion-source-detail"
                                            >
                                                <td><span class="conversion-source-detail-label"><i class="bx bx-subdirectory-right mr-1"></i>{{ breakdown.breakdown }}</span></td>
                                                <td class="text-right">{{ formatNumber(breakdown.total) }}</td>
                                                <td class="text-right">{{ formatNumber(breakdown.matriculados) }}</td>
                                                <td class="text-right font-weight-bold">{{ formatPercentage(breakdown.conversion_rate) }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="fuenteSeleccionadaMetric" class="career-conversion-breakdown mb-4">
                            <div class="d-flex flex-wrap align-items-center justify-content-between mb-2">
                                <div>
                                    <h5 class="mb-1">Conversión a carrera: {{ fuenteSeleccionadaMetric.source }}</h5>
                                    <small class="text-muted">
                                        Distribución de los {{ formatNumber(fuenteSeleccionadaMetric.matriculados) }} matriculados de esta fuente.
                                    </small>
                                </div>
                                <button type="button" class="btn btn-sm btn-light mt-2 mt-md-0" @click="selectSource(fuenteSeleccionadaMetric)">
                                    <i class="bx bx-x mr-1"></i> Cerrar
                                </button>
                            </div>
                            <div v-if="fuenteSeleccionadaMetric.career_breakdown.length" class="table-responsive">
                                <table class="table table-sm table-hover mb-0 career-conversion-table">
                                    <thead>
                                        <tr>
                                            <th>Carrera</th>
                                            <th class="text-right">Matriculados</th>
                                            <th class="text-right">% de la conversión</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="career in fuenteSeleccionadaMetric.career_breakdown" :key="`${fuenteSeleccionadaMetric.source_value}-${career.career}`">
                                            <td>{{ career.career }}</td>
                                            <td class="text-right">{{ formatNumber(career.matriculados) }}</td>
                                            <td class="text-right font-weight-bold">{{ formatPercentage(career.percentage) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-muted small">
                                No hay matriculados con carrera informada para esta fuente.
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </component>
</template>

<style scoped>
.dashboard-advance-header {
    background: linear-gradient(135deg, #252c5f 0%, #3678a8 55%, #61b7e4 100%);
    border-radius: 4px 4px 0 0;
}

.advance-sync-toolbar {
    border: 1px solid #dce8f1;
    background: linear-gradient(135deg, #f8fbfd 0%, #eef6fa 100%);
}

.advance-sync-toolbar-icon {
    color: #286f8d;
    font-size: 32px;
    line-height: 1;
}

.advance-sync-progress {
    max-width: 720px;
}

.advance-sync-progress-bar {
    height: 10px;
    border-radius: 999px;
    background: #dce8f1;
}

.advance-sync-progress-bar .progress-bar {
    min-width: 2px;
    border-radius: 999px;
    background: linear-gradient(90deg, #286f8d 0%, #4ca4a1 100%);
    transition: width .5s ease;
}

.advance-period-report-card {
    overflow: hidden;
}

.advance-period-report-header {
    background: linear-gradient(135deg, #183b56 0%, #286f8d 55%, #4ca4a1 100%);
}

.advance-lead-qualification-header {
    background: linear-gradient(135deg, #25305f 0%, #5965a8 55%, #4ca4a1 100%);
}

.tuition-report-card {
    overflow: hidden;
}

.tuition-report-header {
    background: linear-gradient(135deg, #173f5f 0%, #206a7b 52%, #2f9c95 100%);
}

.tuition-report-filters label {
    color: rgba(255, 255, 255, .78);
    font-size: 11px;
    letter-spacing: .04em;
    text-transform: uppercase;
}

.tuition-report-filters select {
    display: block;
    min-width: 145px;
    margin-top: 3px;
    color: #173f5f;
    text-transform: none;
}

.tuition-summary-main {
    position: relative;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
    padding: 16px;
    border: 1px solid #dbece9;
    border-radius: 8px;
    background: #f5fbfa;
}

.tuition-summary-main div,
.tuition-group-card {
    display: flex;
    flex-direction: column;
}

.tuition-summary-main small,
.tuition-group-card span {
    color: #667782;
    font-size: 11px;
    letter-spacing: .05em;
    text-transform: uppercase;
}

.tuition-summary-main strong {
    color: #173f5f;
    font-size: 20px;
}

.tuition-summary-main .tuition-money strong {
    color: #14867d;
}

.tuition-missing-modal-link {
    align-self: flex-start;
    margin: 3px 0 0;
    padding: 0;
    color: #14867d;
    font-size: 12px;
    text-align: left;
}

.tuition-missing-modal-link:hover,
.tuition-hubspot-link {
    color: #206a7b;
}

.tuition-missing-modal-list strong {
    color: #173f5f;
}

.tuition-hubspot-link {
    display: block;
    margin-top: 8px;
    font-size: 12px;
}

.tuition-loader {
    position: absolute;
    top: 12px;
    right: 12px;
    color: #14867d;
    font-size: 22px;
}

.tuition-group-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.tuition-group-card {
    padding: 14px;
    border-left: 4px solid #2f9c95;
    border-radius: 6px;
    background: #f7f9fc;
}

.tuition-group-card strong {
    margin: 4px 0;
    color: #173f5f;
    font-size: 18px;
}

.tuition-group-card small {
    color: #77838f;
}

.tuition-career-table thead th {
    border-bottom-width: 1px;
    background: #f7f9fc;
    color: #405261;
    font-size: 12px;
}

.tuition-career-table td {
    vertical-align: middle;
}

.tuition-career-table td .badge {
    font-weight: 400;
}

.tuition-group-badge {
    color: #31546d;
}

@media (max-width: 767px) {
    .tuition-summary-main,
    .tuition-group-grid {
        grid-template-columns: 1fr;
    }

    .tuition-report-filters {
        width: 100%;
    }

    .tuition-report-filters label,
    .tuition-report-filters select {
        width: 100%;
    }

    .tuition-report-filters label {
        margin-right: 0 !important;
        margin-bottom: 8px !important;
    }
}

.advance-period-report-period {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    color: #fff;
}

.advance-period-report-period small {
    color: rgba(255, 255, 255, .7);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: .08em;
}

.advance-period-report-period strong {
    color: #fff;
    font-size: 18px;
    line-height: 1.2;
}

.advance-period-report-select {
    width: 130px;
    height: 34px;
    border-color: rgba(255, 255, 255, .45);
    background-color: rgba(255, 255, 255, .96);
    color: #183b56;
    font-size: 16px;
    font-weight: 700;
    text-align-last: center;
}

.advance-report-stage-grid {
    display: grid;
    grid-template-columns: repeat(7, minmax(120px, 1fr));
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 2px;
}

.advance-lead-qualification-grid {
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    overflow-x: visible;
}

.advance-report-stage-item {
    min-width: 120px;
}

.advance-report-pipeline-control {
    display: flex;
    align-items: center;
    color: #252c5f;
}

.advance-report-pipeline-control .custom-select {
    width: auto;
    min-width: 178px;
    height: 28px;
    border-color: #cbd8e6;
    color: #252c5f;
    font-size: 12px;
    font-weight: 600;
    background-color: #eef2fb;
}

.advance-report-stage {
    min-height: 64px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #e2eaf0;
    border-radius: 7px;
    background: #f8fafc;
    padding: 10px 12px;
}

.advance-report-stage span {
    color: #5f6b7a;
    font-size: 11px;
    line-height: 1.25;
}

.advance-report-stage strong {
    color: #183b56;
    font-size: 20px;
    line-height: 1;
    margin-top: 6px;
}

.advance-lead-qualification-stage-button {
    width: 100%;
    cursor: pointer;
    text-align: left;
}

.advance-lead-qualification-stage-button:disabled {
    cursor: wait;
}

.advance-lead-qualification-stage-active {
    border-color: #252c5f;
    background: #eef2fb;
    box-shadow: inset 0 0 0 2px rgba(37, 44, 95, .45), 0 2px 8px rgba(37, 44, 95, .12);
}

.advance-lead-qualification-stage-active span,
.advance-lead-qualification-stage-active strong {
    color: #252c5f;
}

.advance-assignment-breakdown {
    border-top: 1px solid #edf1f5;
    padding-top: 18px;
}

.advance-assignment-owner-table {
    border: 1px solid #edf1f5;
    border-radius: 7px;
}

.advance-assignment-owner-table th {
    border-top: 0;
    color: #5f6b7a;
    font-size: 11px;
    text-transform: uppercase;
}

.advance-assignment-owner-table tfoot th {
    border-top: 1px solid #dbe5ee;
    color: #252c5f;
    font-size: 12px;
    background: #f8fafc;
}

.advance-report-stage-matriculado {
    background: #eef8f5;
    border-color: #b8dfd2;
}

.advance-report-stage-matriculado strong {
    color: #16836d;
}

.advance-lead-qualification-stage {
    background: #f8f7ff;
    border-color: #d8d5f0;
}

.advance-lead-qualification-stage strong {
    color: #4f5ba6;
}

.advance-lead-qualification-stage.advance-lead-qualification-stage-active {
    border-color: #252c5f;
    box-shadow: inset 0 0 0 2px rgba(37, 44, 95, .45), 0 2px 8px rgba(37, 44, 95, .12);
}

.advance-report-career-icon {
    color: #286f8d;
    font-size: 28px;
}

.advance-report-career-table-wrapper {
    max-height: none;
    overflow: visible;
    border: 1px solid #e7ebf3;
    border-radius: 6px;
}

.advance-report-career-table-wrapper table {
    width: 100%;
    min-width: 0;
}

.advance-report-career-table-wrapper thead th {
    background: #f7f9fc;
    border-bottom-width: 1px;
    color: #252c5f;
    font-size: 12px;
}

.advance-report-career-table-wrapper td {
    font-size: 12px;
    vertical-align: middle;
}

.advance-report-career-table-wrapper tfoot th {
    background: #f7f9fc;
    border-top-width: 1px;
    color: #183b56;
    font-size: 12px;
}

.advance-career-visibility-toolbar {
    background: #f7f9fc;
    border: 1px solid #e7ebf3;
    border-radius: 6px;
    padding: 8px 10px;
}

.advance-career-visibility-select {
    width: 112px;
}

.advance-report-goal-cell-sm {
    width: 84px;
    min-width: 84px;
    max-width: 84px;
}

.advance-report-goal-cell-xs {
    width: 68px;
    min-width: 68px;
    max-width: 68px;
}

.advance-report-previous-period-col {
    width: 98px;
    min-width: 98px;
    max-width: 98px;
    line-height: 1.15;
    white-space: normal;
}

.advance-report-growth-col {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
    line-height: 1.15;
    white-space: normal;
}

.advance-report-action-col {
    width: 58px;
    min-width: 58px;
    max-width: 58px;
    text-align: center;
}

.advance-report-action-col .btn {
    align-items: center;
    display: inline-flex;
    font-size: 15px;
    height: 28px;
    justify-content: center;
    line-height: 1.2;
    padding: 0;
    width: 28px;
}

.advance-report-career-hidden {
    background: #f9fafc;
    color: #6b7280;
}

.advance-report-goal-cell-sm .form-control,
.advance-report-goal-cell-xs .form-control {
    font-size: 12px;
    height: 30px;
    padding: 4px 6px;
}

.dashboard-advance-icon {
    color: rgba(255, 255, 255, .82);
    font-size: 48px;
}

.dashboard-advance-summary {
    background: #f7f9fc;
    border: 1px solid #e7ebf3;
    border-radius: 6px;
    padding: 12px 16px;
}

.lead-period-summary {
    border: 1px solid #e7ebf3;
    border-radius: 6px;
    padding: 12px 16px;
}

.lead-period-table {
    max-width: 560px;
}

.lead-period-table thead th {
    background: #f7f9fc;
    border-bottom-width: 1px;
    color: #252c5f;
    font-size: 12px;
}

.lead-period-table td {
    font-size: 12px;
}

.conversion-breakdown {
    border: 1px solid #e7ebf3;
    border-radius: 6px;
    padding: 16px;
}

.conversion-table thead th {
    background: #f7f9fc;
    border-bottom-width: 1px;
    color: #252c5f;
    font-size: 12px;
}

.conversion-table td {
    font-size: 12px;
    vertical-align: middle;
}

.conversion-paid-search {
    background: #f0f8f5;
}

.conversion-source-row {
    cursor: pointer;
}

.conversion-source-row:hover,
.conversion-source-row:focus,
.conversion-selected-source {
    background: #eef5fb;
    outline: none;
}

.conversion-source-detail {
    background: #fafbfd;
}

.conversion-source-detail td:first-child {
    padding-left: 32px;
}

.conversion-source-detail-label {
    color: #5f6b7a;
    font-size: 12px;
}

.career-conversion-breakdown {
    border: 1px solid #e7ebf3;
    border-radius: 6px;
    padding: 16px;
}

.career-conversion-table thead th {
    background: #f7f9fc;
    border-bottom-width: 1px;
    color: #252c5f;
    font-size: 12px;
}

.career-conversion-table td {
    font-size: 12px;
    vertical-align: middle;
}

</style>
